import {Scheduler} from '@/constants/actionType';

const initialState = {
  showScheduleRunModal: false,
  isSetScheduleRun: false,
  isScheduleWillRun: false,
  scheduleType: null,
  scheduleId: null,
  startTime: '',
  deltaTime: '',
};

export default function autoProfileState(state = initialState, action = {}) {
  switch (action.type) {
    case Scheduler.SET_SHOW_SCHEDULE_RUN_MODAL:
      return {...state, showScheduleRunModal: action.value};

    case Scheduler.SET_SCHEDULE_RUN:
      return {...state, isSetScheduleRun: action.value};

    case Scheduler.SET_SCHEDULE_REMINDER:
      return {...state, isScheduleWillRun: action.value};

    case Scheduler.SET_SCHEDULE_TYPE:
      return {...state, scheduleType: action.value};

    case Scheduler.SET_SCHEDULE_ID:
      return {...state, scheduleId: action.value};

    case Scheduler.SET_START_TIME:
      return {...state, startTime: action.value};

    case Scheduler.SET_DELTA_TIME:
      return {...state, deltaTime: action.value};

    case Scheduler.RESET:
      return initialState;
    default:
      return state;
  }
}
